import React from 'react';
import { FadeIn, Section, SectionLabel, Card } from './UI';
export const BonusSection = () => {
  return <Section className="bg-pageBg" data-id="element-39">
      <FadeIn data-id="element-40">
        <Card className="p-8 md:p-12 relative overflow-hidden" data-id="element-41">
          <div className="relative z-10 flex flex-col md:flex-row items-center gap-8" data-id="element-42">
            <div className="shrink-0" data-id="element-43">
              <div className="w-24 h-24 md:w-32 md:h-32 bg-deepPurple rounded-2xl flex items-center justify-center text-5xl md:text-6xl shadow-lg" data-id="element-44">
                🎁
              </div>
            </div>

            <div className="flex-1 text-center md:text-left" data-id="element-45">
              <SectionLabel data-id="element-46">Bonus Incluido</SectionLabel>
              <h2 className="font-serif text-[clamp(1.6rem,3.5vw,2.2rem)] leading-[1.2] text-headline mb-4 font-bold" data-id="element-47">
                Plantilla de{' '}
                <span className="text-accent" data-id="element-48">Operating Agreement</span>
              </h2>
              <p className="text-[1.02rem] text-body mb-6 leading-relaxed" data-id="element-49">
                Lista para usar. Sirve tanto para LLC unipersonal como para LLC
                con socios. Solo completa los datos y úsala en el banco.
              </p>
              <div className="flex flex-wrap gap-4 items-center justify-center md:justify-start" data-id="element-50">
                <span className="text-[0.9rem] line-through text-body" data-id="element-51">
                  Valor real: $47
                </span>
                <span className="bg-cardBorder text-accent px-5 py-[6px] rounded-full text-[0.85rem] font-bold tracking-wide" data-id="element-52">
                  INCLUIDA GRATIS
                </span>
              </div>
            </div>
          </div>
        </Card>
      </FadeIn>
    </Section>;
};